import React from 'react';
import paginationNextDisabled from '../assets/images/pagination-next-disabled.svg';

export default () => {
  return <img src={paginationNextDisabled} alt="Next Page Disabled" />;
};
